<template>
  <div class="detail">
    <main class="box" v-if="this.mid.includes('-') ===false || this.mid === 'c8-12' || this.mid === 'c9-20' || this.mid === 'c10-558'">
      <div class="title">
        <p class="d-title">{{data.title}}</p>
        <p class="date">{{data.date}} &nbsp;&nbsp;&nbsp;{{this.catname}}</p>
      </div>
      <div class="content-wrap" id="gif">
        <div class="content-info">
        <el-image-viewer  v-if="showClickImage" :on-close="$closeViewer" :url-list="srcList" />
          <div v-html="data.content" v-on:click="$contentClick($event,data.content)"></div>
          <div class="vip" v-show="data.status === 0" @click="handleTry('try')">会员专享</div>
        </div>
      </div>

      <div class="desc">
        <p>【重要声明及风险提示】：</p>
        <p class="risk">本报告中的信息均来源于已公开的资料，我公司对这些信息的准确性及完整性不作任何保证。在任何情况下，报告中的信息或所表达的意见并不构成所述证券买卖建议。在任何情况下，我公司不就本报告中的任何内容对任何投资做出任何形式的担保。本报告版权归博览财经所有。未获得博览财经事先书面授权，任何人不得对本报告进行任何形式的发布、复制。如引用、刊发，需注明出处为“武汉博览财经信息技术股份有限公司”，且不得对本报告进行有悖原意的删节和修改。</p>
      </div>
    </main>


    <main class="box" v-if="this.mid.includes('-') ===true && this.mid !== 'c8-12' && this.mid !== 'c9-20'  && this.mid !== 'c10-558'">
      <div class="title">
        <p class="d-title">{{data.title}}</p>
        <p class="date">{{data.date}} &nbsp;&nbsp;&nbsp;{{this.catname}}</p>
      </div>
      <div class="content-wrap">
        <div class="combo-box" v-for="(item, i) in comboData" :key="i">
          <div class="m-name">{{item.name}}</div>
          <el-image-viewer v-if="showClickImage" :on-close="$closeViewer" :url-list="srcList" />
          <div v-html="item.content" v-on:click="$contentClick($event,item.content)"></div>
        </div>

        <div class="vip" v-show="data.status === 0" @click="handleTry('try')">会员专享</div>
      </div>

      <div class="desc">
<!--        <p>【产品简介】：</p>-->
<!--        <p class="cp-intro">解读高层政策动向，把握全球经济脉搏，寻找资产配置的“经济基础”、“资金动力”以及“新闻牵引力”。并在A股“政策市特征”下，按照自上而下的分析逻辑，预判A股中长期大趋势、大机会，兼顾短线的投机确定性。</p>-->
        <p>【重要声明及风险提示】：</p>
        <p class="risk">本报告中的信息均来源于已公开的资料，我公司对这些信息的准确性及完整性不作任何保证。在任何情况下，报告中的信息或所表达的意见并不构成所述证券买卖建议。在任何情况下，我公司不就本报告中的任何内容对任何投资做出任何形式的担保。本报告版权归博览财经所有。未获得博览财经事先书面授权，任何人不得对本报告进行任何形式的发布、复制。如引用、刊发，需注明出处为“武汉博览财经信息技术股份有限公司”，且不得对本报告进行有悖原意的删节和修改。</p>
      </div>
    </main>

    <div class="back-top" @click="backTop" v-show="btnFlag">
      <img src="../assets/images/return_top.png" alt="" srcset="">
    </div>

    <login v-if="VisiAbleLg" ref="dialogLg"></login>
    <vip v-if="VisiAble" ref="dialog"></vip>
  </div>
</template>

<script>
import Login from "@/components/common/Login";
import Vip from "@/components/common/vip";
import { Detail, Combo } from "@/api/news";
import { History } from "@/api/user";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: "Detail",
  components:{
    Login,
    Vip,
    ElImageViewer
  },
  data() {
    return {
      data: [],
      srcList: [],
      showClickImage: false,
      id: this.$route.query.id,
      mid: this.$route.query.mid,
      catname: this.$route.query.catname,
      username: window.localStorage.getItem('username'),
      btnFlag:false,
      VisiAble: false,
      VisiAbleLg: false,
      name: '',
      contentData: '',
      comboData: [],
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.init();
    this.viewHistory();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
  },
  updated() {
    $("a").not("[href^='pdf']").prev("img").css('cssText','width:30px !important;display:unset;vertical-align: middle');
  },
  methods: {
    //内容点击事件，主要是为了解决图片弹层问题
    $contentClick(event, item) {
      const target = event.target;
      if (target.tagName === 'IMG') {
        event.preventDefault();
        const content = item;
        let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
        let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
        let arr = content.match(imgReg); //筛选出所有的img
        let srcArr = [];
        for (let i = 0; i < arr.length; i++) {
          let src = arr[i].match(srcReg);
          // 获取图片地址
          srcArr.push(src[1]);
        }
          this.srcList = srcArr
        console.log(this.srcList);
        this.showClickImage = true
      }
    },
    // 关闭查看器
    $closeViewer() {
      this.showClickImage = false
    },
    handleTry(data) {
      const token = window.localStorage.getItem('token')
      if(!token){
        this.VisiAbleLg = true;
        this.$nextTick(() => {
          this.$refs.dialogLg.init('lg');
        });
      }else{
        // 已登录用户跳转至会员购买页
        this.$router.push({path: '/Member'});
      }
    },
    init: function () {
      let data = {
        id: this.id,
        mid: this.mid,
      };
      if(this.mid.includes("-")){
        if(this.mid !== 'c8-12' && this.mid !== 'c9-20' && this.mid !== 'c10-558'){
          Combo( data ).then(( response ) => {
            if(response.code === 2000){
            var str = response.data.content
            if(response.data.status === 1){
              var con = JSON.parse(str)
              var key = Object.keys(con)
            }
            // console.log(key);
            if(this.mid === 'c1-21'){
              const catName = '收盘观潮';
              // console.log(catName);
              var arr = [465, 24, 21, 30, 38];
              var data = {465: "每日视点", 24: "收盘展望", 21: "热点解析", 30: "强势股解析", 38: "涨停分析"};
            }
            if(this.mid === 'c4-268'){
              const catName = '盘前点金';
              // console.log(catName);
              var arr = [242,12,466,268,182];
              var data= { 242:"每日策略",12:"每日策略",466:"要闻解读",268:"机会挖掘",182:"机会挖掘"};
            }
            if(this.mid === 'c3-550'){
              const catName = '每日A股大参考';
              // console.log(catName);
              var arr = [547, 548, 550, 551, 549, 106, 4, 56, 52];
              var data = {547: "情报精选", 548: "每日复盘", 550: "题材前瞻", 551: "价值掘金", 549: "产业纵横",106: "深度调研", 4: "热点聚焦", 56: "投资日历", 52: "机密爆料"};
            }
            if(this.mid === 'c7-555'){
              const catName = '港股投资参考';
              // console.log(catName);
              var arr = [351, 555, 352, 556, 353, 354];
              var data = {351: "趋势展望", 555: "要闻点评", 352: "数据追踪", 556: "行业全景", 353: "港股攻略",354: "八面来风"};
            }
            if(this.mid === 'c2-426'){
              const catName = '数据解盘';
              // console.log(catName);
              var arr = [74,423,424,425,426,427,429,430,431];
              var data = {74:"融资融券",423:"主力持仓（行业）",424:"主力持仓（个股）",425:"龙虎追踪",426:"大宗解密",427:"业绩预告",429:"限售解禁",430:"主力持仓（行业）",431:"主力持仓（个股）"};
            }
            if(this.mid === 'c6-401'){
              const catName = '可转债投资指南';
              // console.log(catName);
              var arr = [399,400,401,402,403,404,405  ];
              var data= { 399:"昨日上新",400:"今日上市",401:"转债组合",402:"强赎警报",403:"人气之星",404:"转债风口",405:"转债小课堂"};
            }
            if(this.mid === 'c5-408'){
              const catName = 'ETF投资参考';
              // console.log(catName);
              var arr = [406,407,408,409,410];
              var data= { 406:"ETF策略",407:"行情聚焦",408:"众里寻E",409:"潜力E会",410 :"资讯速递"};
            }
            for(let i in arr){
              for(let k in key){
                if(arr[i] == key[k]){
                  var k1 = key[k];
                  const name = data[k1];
                  // if(arr[i] === 423 || arr[i] === 424 || arr[i] === 430 || arr[i] === 431 ){
                  //   console.log(name);
                  // }else{
                    this.name = name
                    // console.log(name);
                    this.contentData = this.$Base64.decode(con[k1]);
                    var arr1 = {
                      name:name,
                      content:this.contentData
                    }
                    this.comboData.push(arr1)
                  // }
                }
              }
            }
            this.data = response.data
          }
        });
        }else if(this.mid === 'c10-558'){
          Detail( data ).then(( response ) => {
            console.log(1);
            if(response.code === 2000){
              this.data = response.data
            }
          });
        }else{
          Detail( data ).then(( response ) => {
            console.log(1);
            if(response.code === 2000){
              this.data = response.data
            }
          });
        }
      }else{
        Detail( data ).then(( response ) => {
          if(response.code === 2000){
            this.data = response.data
          }
        });
      }
    },
    viewHistory(){
      History({username:this.username,id: this.id, mid: this.mid, catname: this.catname}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403 || response.code === 200) {
          // console.log(response.msg)
        }
      });
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop () {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
  }
}
</script>

<style scoped>
.detail {
  margin-top: 60px;
  margin-bottom: 20px;
}

.box {
  width: 1200px;
  margin: 0 auto;
}

>>>table{
  margin: 0 auto;
}

.title {
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  padding: 31px 0 16px 60px;
  margin-top: 60px;
}

.d-title{
  font-size: 24px;
  font-weight: 600;
}

.date{
  font-size: 14px;
  color: #959595;
  margin-top: 15px;
}

.content-wrap {
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  padding: 31px 0 15px 0;
  font-size: 20px;
  line-height: 40px;
}

.content-info{
  padding: 0 64px;
}

.m-name{
  font-weight: 600;
  font-size: 20px;
  color: #021847;
}

.content-wrap .combo-box{
  border-bottom: 8px solid #F5F7FA;
  padding: 10px 64px!important;
}

.combo-box:last-of-type {
  border-bottom: unset;
}

.vip{
  height: 40px;
  background-color: #001646;
  border-radius: 20px;
  color: white;
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  margin: 30px auto;
  width: 50%;
  cursor: pointer;
}

.desc {
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0,0.1);
  margin-top: 30px;
  padding: 31px 63px 43px 64px;
  color: gray;
}

.cp-intro{
  margin-top: 10px;
  margin-bottom: 15px;
  line-height: 24px;
}

.risk{
  margin-top: 10px;
  line-height: 24px;
}

.back-top{
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue